import { selectMedication } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  MedicationSelectResultT,
  SelectMedicationParams,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchSelectMedication(
  params: SelectMedicationParams,
  signal?: AbortSignal
): Promise<MedicationSelectResultT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await selectMedication(params, config);
  return lotusHealthZod.selectMedicationResponse.parse(response.data) as MedicationSelectResultT;
}
